import { MVTLayer } from "deck.gl";
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions";
import { linearScale } from "../singleLayer/renderLayerService";

export function UhiUrbanHeatLayer(workspace, layerName, is3D, opacity) {
    let domain = [0.20978, 2.2515, 5.242860000000003]
    let range = [[102, 153, 255], [255, 255, 102], [255, 102, 102]]
    const dataSource = generateUrlGeoserverVector(workspace, layerName)
    if (layerName == 'urban-heat-islands-day-indonesia') {
        domain = [-0.509784, 2.747237, 5.7394]
    }
    else {
        domain = [-0.805040, 0.479634, 1.837273]
    }

    return [
        new MVTLayer({
            id: `AdmninistrativeDayPop`,
            data: dataSource,
            onTileLoad: showLoading,
            onViewportLoad: hideLoading,
            opacity: opacity / 100,
            stroked: true,
            filled: true,
            //extruded: is3D,
            // wireframe: false,
            getLineColor: f => linearScale(f.properties.d_median, domain, range),
            getFillColor: f => {
                return linearScale(f.properties.d_median, domain, range)
            },
            getLineWidth: 1.0,
            lineWidthMinPixels: 1.0,
            pickable: true,
            terrainDrawMode: is3D ? 'offset' : '',
            extensions: is3D ? [new TerrainExtension()] : [],
        }),
    ]
}